module.exports = __webpack_public_path__ + "img/je.89207890.svg";